function AllInclusive({ dimensions, col = '#000' }) {
  const baseXml = `

    <svg width=${dimensions || '24'} height=${dimensions || '24'} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M49.6 17.6533C45.76 17.6533 42.1333 19.1467 39.5467 21.7333L20.8 38.3733C19.0933 40.08 16.8267 41.0133 14.4 41.0133C9.41333 41.0133 5.36 36.9867 5.36 32C5.36 27.0133 9.41333 22.9867 14.4 22.9867C16.8267 22.9867 19.0933 23.92 20.9067 25.7333L23.92 28.4L27.9467 24.8267L24.5867 21.8667C21.8667 19.1467 18.24 17.6533 14.4 17.6533C6.45333 17.6533 0 24.1067 0 32C0 39.8933 6.45333 46.3466 14.4 46.3466C18.24 46.3466 21.8667 44.8533 24.4533 42.2667L43.2 25.6267C44.9067 23.92 47.1733 22.9867 49.6 22.9867C54.5867 22.9867 58.64 27.0133 58.64 32C58.64 36.9867 54.5867 41.0133 49.6 41.0133C47.2 41.0133 44.9067 40.08 43.0933 38.2667L40.0533 35.5733L36.0267 39.1467L39.4133 42.1333C42.1333 44.8267 45.7333 46.32 49.6 46.32C57.5467 46.32 64 39.8933 64 31.9733C64 24.0533 57.5467 17.6533 49.6 17.6533Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default AllInclusive;
